import React, { useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import { addProviderBank } from '../../../../store/actions/ProviderActions';
import { getDictionaryByKeyAction } from '../../../../store/actions/AdministrationAction';
import { Button, Modal } from "react-bootstrap";
import Select from 'react-select';
import { useTranslation } from "react-i18next";

export const BankInfosModal = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { providerRef, manageBankModal, history } = props;
    const [bankName, setBankName] = useState(providerRef.bankDetails[providerRef.bankDetails.length - 1]?.bankName || "");
    const [bankCode, setBankCode] = useState(providerRef.bankDetails[providerRef.bankDetails.length - 1]?.bankCode || "");
    const [swift, setSwift] = useState(providerRef.bankDetails[providerRef.bankDetails.length - 1]?.swift || "");
    const [numeroBanque, setNumeroBanque] = useState(providerRef.bankDetails[providerRef.bankDetails.length - 1]?.numeroBanque || "");
    const [cleRib, setCleRib] = useState(providerRef.bankDetails[providerRef.bankDetails.length - 1]?.cleRib || "");
    const [intituleBanque, setIntituleBanque] = useState(providerRef.bankDetails[providerRef.bankDetails.length - 1]?.intituleBanque || "");
    const [fileSrc, setFileSrc] = useState(null);

    const [paymentMeans, setPaymentMeans] = useState(providerRef.mobilePaymentDetails || []);

    const [banks, setBanks] = useState([]);
    const [operators, setOperators] = useState([]);

    const fromProvider = true;

    useEffect(() => {
        // Fetch banks for dropdown
        dispatch(getDictionaryByKeyAction('banque'))
            .then(result => {
                if (result.success) {
                    setBanks(result.data);
                }
            })
            .catch(error => {
                console.error('Error fetching banks:', error);
            });

        // Fetch operators for dropdown
        dispatch(getDictionaryByKeyAction('operateur'))
            .then(result => {
                if (result.success) {
                    setOperators(result.data);
                }
            })
            .catch(error => {
                console.error('Error fetching operators:', error);
            });
    }, [dispatch]);

    const saveProviderBankInfos = () => {

        const data = {
            providerId: providerRef.id,
            bankDetail: {
                bankName,
                fileSrc,
                bankCode,
                swift,
                rib: cleRib,
                accountName: intituleBanque,
                accountNumber: numeroBanque,
            },
            paymentMeans,
            fromProvider,
        };

        dispatch(addProviderBank(data, history));
        manageBankModal(false, true);

    }

    const checkFormValidity = () => {
        if(bankName.length === 0 && bankCode.length === 0 && swift.length === 0 &&
            numeroBanque.length === 0) {
                return true;
        }

        if(bankName.length === 0) {
            return true;
        }

        if(bankName.length > 0 && (bankCode.length === 0 || swift.length === 0 || numeroBanque.length === 0)){
            return true;
        }

        return false
    }

    const addRIB = (e) => {
        let upFiles = e.target.files;
        const keys = Object.keys(upFiles);
        setFileSrc(upFiles[keys[0]]);
    }

    const loadIdentityFile = (e, paymentMean) => {
        let upFiles = e.target.files;
        const keys = Object.keys(upFiles);
        setPaymentMeans(paymentMeans.map(payM => { 
            if(payM.id === paymentMean.id){
                payM.file = upFiles[keys[0]];
            }
            return payM;
        }));
    }

    return (
            <>
                <Modal.Header>
                    <Modal.Title>{providerRef.bankDetails.length > 0 ? t('provider.modifInfoBank') : t('provider.creationInfoBank')}</Modal.Title>
                    <Button
                        variant=""
                        className="close"
                        onClick={() => manageBankModal(false, false)}
                    >
                        <span>&times;</span>
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <h5 className='mt-4 text-primary'>{t('provider.bank')}</h5>
                    <div className="border-top mt-2 mb-4"></div>
                    <div className='row justify-content-between align-items-center'>
                        <div className='col-4 form-group'>
                            <label className='mb-1 '>
                                <strong>{t('provider.bank')}</strong>
                            </label>
                            <Select
                                className="select-search"
                                value={banks?.filter(b => b.nameFr === bankName).map(b => ({label: b.nameFr, value: b.nameFr}))[0] || null}
                                placeholder="Choisir une banque"
                                onChange={(val) => setBankName(val?.value || '')}
                                options={banks?.map(b => ({label: b.nameFr, value: b.nameFr}))}
                                isClearable
                            />
                        </div>
                        <div className='col-4 form-group'>
                            <label className='mb-1 '>
                                <strong>{t('provider.title-account')}</strong>
                            </label>
                            <input type='text' className='form-control'
                                value={intituleBanque}
                                onChange={(e) => setIntituleBanque(e.target.value)}
                            />
                        </div>
                        <div className='col-4 form-group'>
                            <label className='mb-1 '>
                                <strong>RIB</strong>
                            </label>
                            <div>
                                <div className='input-group'>
                                    <div className='custom-file'>
                                        <input type="file" required={bankName.length > 0} className='custom-file-input' onChange={(e) => addRIB(e)} />
                                        <label className='custom-file-label'>{fileSrc ? <small>{fileSrc.name}</small> : t('common.choose')}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row justify-content-between align-items-center'>
                        <div className='col-3 form-group'>
                            <label className='mb-1 '>
                                <strong>{t('provider.account-number')}</strong>
                            </label>
                            <input type='text' className='form-control'
                                value={numeroBanque}
                                required={bankName.length > 0}
                                disabled={bankName.length === 0}
                                onChange={(e) => setNumeroBanque(e.target.value)}
                            />
                        </div>
                        <div className='col-3 form-group'>
                            <label className='mb-1 '>
                                <strong>{t('common.code')} {t('provider.bank')}</strong>
                            </label>
                            <input type='text' className='form-control'
                                value={bankCode}
                                required={bankName.length > 0}
                                disabled={bankName.length === 0}
                                onChange={(e) => setBankCode(e.target.value)}
                            />
                        </div>
                        <div className='col-3 form-group'>
                            <label className='mb-1 '>
                                <strong>{t('provider.key-RIB')}</strong>
                            </label>
                            <input type='text' className='form-control'
                                value={cleRib}
                                required={bankName.length > 0}
                                disabled={bankName.length === 0}
                                onChange={(e) => setCleRib(e.target.value)}
                            />
                        </div>
                        <div className='col-3 form-group'>
                            <label className='mb-1 '>
                                <strong>{t('provider.swift-code')}</strong>
                            </label>
                            <input type='text' className='form-control'
                                value={swift}
                                required={bankName.length > 0}
                                disabled={bankName.length === 0}
                                onChange={(e) => setSwift(e.target.value)}
                            />
                        </div>
                    </div>

                    <h5 className='mt-4 text-primary'>{t('provider.mobileInt')}</h5>
                    <div className="border-top mt-2 mb-4"></div>
                    {
                        paymentMeans.map((paymentMean) => {
                            return <>
                                <div className='row justify-content-between align-items-center'>
                                    <div className='col-4 form-group'>
                                        <label className='mb-1 '>
                                            <strong>{t('provider.operator')}</strong>
                                        </label>
                                        <Select
                                            className="select-search"
                                            value={operators?.filter(op => op.nameFr === paymentMean.operator).map(op => ({label: op.nameFr, value: op.nameFr}))[0] || null}
                                            placeholder="Choisir un opérateur"
                                            onChange={(val) => setPaymentMeans(paymentMeans.map(payM => {
                                                if(payM.id === paymentMean.id){
                                                    payM.operator = val?.value || '';
                                                }
                                                return payM;
                                            }))}
                                            options={operators?.map(op => ({label: op.nameFr, value: op.nameFr}))}
                                            isClearable
                                        />
                                    </div>
                                    <div className='col-4 form-group'>
                                        <label className='mb-1 '>
                                            <strong>{t('provider.phone')}</strong>
                                        </label>
                                        <input type='phone' className='form-control'
                                            value={paymentMean.phonenumber}
                                            required={paymentMean.operator.length > 0}
                                            onChange={(e) => setPaymentMeans(paymentMeans.map(payM => { 
                                                    if(payM.id === paymentMean.id){
                                                        payM.phonenumber = e.target.value;
                                                    }
                                                    return payM;
                                                }))
                                            }
                                        />
                                    </div>
                                    <div className='col-4 form-group'>
                                        <label className='mb-1 '>
                                            <strong>{t('provider.ownerfullname')}</strong>
                                        </label>
                                        <input type='phone' className='form-control'
                                            value={paymentMean.beneficialName}
                                            required={paymentMean.operator.length > 0}
                                            onChange={(e) => setPaymentMeans(paymentMeans.map(payM => { 
                                                    if(payM.id === paymentMean.id){
                                                        payM.beneficialName = e.target.value;
                                                    }
                                                    return payM;
                                                }))
                                            }
                                        />
                                    </div>
                                </div>
                                
                                <div className='row justify-content-between align-items-center'>
                                    <div className='col-4 form-group'>
                                        <label className='mb-1 '>
                                            <strong>{t('provider.typeIdenDoc')}</strong>
                                        </label>
                                        <select
                                            defaultValue={paymentMean.idType}
                                            className='form-control form-control-lg'
                                            onChange={(e) => setPaymentMeans(paymentMeans.map(payM => {
                                                    if(payM.id === paymentMean.id){
                                                        payM.idType = e.target.value;
                                                    }
                                                    return payM;
                                                }))
                                            }
                                        >
                                            <option value='option'>
                                            {t('common.choose')}
                                            </option>
                                            <option value='cni'>{t('provider.id-card')}</option>
                                            <option value='passeport'>{t('provider.passport')}</option>
                                            <option value='contribuable'>{t('provider.taxpayer')}</option>
                                        </select>
                                    </div>
                                    <div className='col-4 form-group'>
                                        <label className='mb-1 '>
                                            <strong>{t('provider.num-ident')}</strong>
                                        </label>
                                        <input type='phone' className='form-control'
                                            value={paymentMean.idNumber}
                                            onChange={(e) => setPaymentMeans(paymentMeans.map(payM => {
                                                    if(payM.id === paymentMean.id){
                                                        payM.idNumber = e.target.value;
                                                    }
                                                    return payM;
                                                }))
                                            }
                                        />
                                    </div>
                                    <div className='col-4 form-group'>
                                        <label className='mb-1 '>
                                            <strong>{t('provider.ident-doc')}</strong>
                                        </label>
                                        <div>
                                            <div className='input-group'>
                                                <div className='custom-file'>
                                                    <input type="file" className='custom-file-input' onChange={(e) => loadIdentityFile(e, paymentMean)} />
                                                    <label className='custom-file-label'>{paymentMean.file ? <small>{paymentMean.file.name}</small> : t('common.choose')}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        })
                    }
                    
                    <div className='row justify-content-end align-items-center'>
                        <Button
                            variant="outline-secondary"
                            className="sm"
                            onClick={() => setPaymentMeans([...paymentMeans, 
                                {operator: "", phonenumber: "", beneficialName: "", idType: "", idNumber: "", file: null}])}
                        >
                            + {t('consultation.add')}
                        </Button>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="danger light"
                        onClick={() => manageBankModal(false)}
                    >
                       {t('common.cancel')}
                    </Button>
                    <Button
                        variant=""
                        type="button"
                        className="btn btn-primary"
                        disabled={checkFormValidity()}
                        onClick={() => saveProviderBankInfos()}
                    >
                       {t('common.save')}
                    </Button>
                </Modal.Footer>
            </>
    )
};

export default BankInfosModal;